import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useReducer } from "react";
export var RouterContext = /*#__PURE__*/createContext({});
function reducer(state, action) {
  switch (action.type) {
    case 'PUSH':
      return _objectSpread(_objectSpread({}, state), {}, {
        previousView: state.currentView,
        currentView: action.payload.screen,
        params: action.payload.params
      });
    case 'GO_BACK':
      return _objectSpread(_objectSpread({}, state), {}, {
        previousView: state.currentView,
        currentView: state.previousView
      });
    default:
      throw new Error('Action not defined');
  }
}
export var RouterProvider = function RouterProvider(_ref) {
  var children = _ref.children,
    entry = _ref.entry;
  var _useReducer = useReducer(reducer, {
      previousView: '',
      currentView: entry,
      params: {}
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    currentView = _useReducer2$.currentView,
    previousView = _useReducer2$.previousView,
    params = _useReducer2$.params,
    dispatch = _useReducer2[1];
  var push = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(screen) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (typeof screen === 'string') {
              dispatch({
                type: 'PUSH',
                payload: {
                  screen: screen,
                  params: {}
                }
              });
            } else {
              dispatch({
                type: 'PUSH',
                payload: screen
              });
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function push(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var goBack = function goBack() {
    return dispatch({
      type: 'GO_BACK'
    });
  };
  var childArray = React.Children.toArray(children);
  var matchedChild = _findInstanceProperty(childArray).call(childArray, function (child) {
    return child.props.screen === currentView;
  });
  return /*#__PURE__*/React.createElement(RouterContext.Provider, {
    value: {
      push: push,
      goBack: goBack,
      previousView: previousView
    }
  }, /*#__PURE__*/React.cloneElement(matchedChild, {
    params: params
  }));
};